import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { FlexContainer, FlexItem } from '../../../CSS/index.js';
import { Link, MainBodyText } from '../../../Typography/index.js';
const TRACKING_EVENTS = Object.freeze({
    PRIVACY_POLICY: 'PrivacyPolicy',
    TERMS_OF_SERVICE: 'TermsOfService',
    CONTACT_US_BUTTON: 'ContactUsButton'
});
const LINKS = Object.freeze({
    PRIVACY_POLICY: 'https://www.astrumu.com/privacy-policy',
    TERMS_OF_SERVICE: 'https://www.astrumu.com/terms-of-service'
});
const RightBar = ({ onTrackClick, links }) => {
    const theme = useTheme();
    return (_jsx(FlexContainer, { as: "section", style: {
            alignItems: 'center',
            width: '100%',
            gridArea: 'right',
            '@media (min-width: 768px)': {
                alignSelf: 'flex-start',
                width: 'calc(100% / 3)'
            }
        }, children: _jsxs(FlexContainer, { as: "ul", cy: "agreements", style: {
                marginTop: 10,
                width: '100%',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                '@media (min-width: 768px)': {
                    marginTop: 0,
                    alignItems: 'center',
                    flexDirection: 'row'
                }
            }, children: [_jsx(FlexItem, { as: "li", style: {
                        transition: 'all 0.3s ease',
                        margin: '0 0 20px 0',
                        '@media (min-width: 768px)': {
                            margin: '0 30px 0 0'
                        },
                        '&:hover': {
                            color: theme.primaryAccentColor
                        }
                    }, children: _jsx(Link, { element: "a", target: "_blank", cy: "terms-of-service", rel: "noopener noreferrer", href: links?.termsOfService || LINKS.TERMS_OF_SERVICE, onClick: () => onTrackClick &&
                            onTrackClick({ element: TRACKING_EVENTS.TERMS_OF_SERVICE }), children: _jsx(MainBodyText, { element: "span", children: "Terms of Service" }) }) }), _jsx(FlexItem, { as: "li", style: {
                        transition: 'all 0.3s ease',
                        margin: 0,
                        '&:hover': {
                            color: theme.primaryAccentColor
                        }
                    }, children: _jsx(Link, { element: "a", target: "_blank", cy: "privacy-policy", rel: "noopener noreferrer", href: links?.privacyPolicy || LINKS.PRIVACY_POLICY, onClick: () => onTrackClick &&
                            onTrackClick({ element: TRACKING_EVENTS.PRIVACY_POLICY }), children: _jsx(MainBodyText, { element: "span", children: "Privacy Policy" }) }) })] }) }));
};
export default RightBar;
//# sourceMappingURL=index.js.map